import React from 'react';
import { MessageCircle } from 'lucide-react';
import { WHATSAPP_URL } from '../mock';
import Header from '../components/Header';
import Hero from '../components/Hero';
import VideoSection from '../components/VideoSection';
import Benefits from '../components/Benefits';
import DoubleVideo from '../components/DoubleVideo';
import WhatIsADP from '../components/WhatIsADP';
import Courses from '../components/Courses';
import Bonus from '../components/Bonus';
import Features from '../components/Features';
import Achievements from '../components/Achievements';
import Testimonials from '../components/Testimonials';
import Community from '../components/Community';
import Pricing from '../components/Pricing';
import Footer from '../components/Footer';

export default function Home() {
  return (
    <div className="relative">
      <Header />
      <Hero />
      <VideoSection />
      <Benefits />
      <DoubleVideo />
      <WhatIsADP />
      <Courses />
      <Bonus />
      <Features />
      <Achievements />
      <Testimonials />
      <Community />
      <Pricing />
      <Footer />

      <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="wa-float" aria-label="WhatsApp">
        <MessageCircle size={28} />
      </a>
    </div>
  );
}
